import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=4c6066b0&scoped=true"
import script from "./BankAccountList.vue?vue&type=script&lang=js"
export * from "./BankAccountList.vue?vue&type=script&lang=js"
import style0 from "./BankAccountList.vue?vue&type=style&index=0&id=4c6066b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6066b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6066b0')) {
      api.createRecord('4c6066b0', component.options)
    } else {
      api.reload('4c6066b0', component.options)
    }
    module.hot.accept("./BankAccountList.vue?vue&type=template&id=4c6066b0&scoped=true", function () {
      api.rerender('4c6066b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/BankAccountList.vue"
export default component.exports